"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
function getProgramsNumberAndNames(queryParams) {
    if (queryParams === void 0) { queryParams = ""; }
    return __awaiter(this, void 0, void 0, function () {
        var url, configuration, res, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = process.env.FORM_TASK_API + "/v1/programsNumber/" + queryParams;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    configuration = {
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            authorization: "Bearer " + window.token
                        }
                    };
                    return [4, axios_1.default.get(url, configuration)];
                case 2:
                    res = _a.sent();
                    return [2, res.data.payload];
                case 3:
                    error_1 = _a.sent();
                    throw {
                        error: error_1,
                        url: url
                    };
                case 4: return [2];
            }
        });
    });
}
exports.getProgramsNumberAndNames = getProgramsNumberAndNames;
function getProgramCosts(campusState, programNumber) {
    return __awaiter(this, void 0, void 0, function () {
        var url, configuration, res, body, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = process.env.FORM_TASK_API + "/v1/programData/" + campusState + "/" + programNumber;
                    configuration = {
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            authorization: "Bearer " + window.token
                        }
                    };
                    return [4, axios_1.default.get(url, configuration)];
                case 1:
                    res = _a.sent();
                    body = res.data.payload;
                    result = {
                        programName: body.program_name,
                        registrationFee: body.standard_registration_fees,
                        programTuition: body.standard_program_tuition,
                        bookFees: body.book_fees,
                        examFees: body.exam_fees,
                        STRF: body.STRF,
                        academicQuarterCredits: body.academic_quarter_credits,
                        totalCharges: body.total,
                        estimatedTotalCharges: body.total,
                        totalChargesObligated: body.total,
                        clockHours: body.clock_hours,
                        weeks12Hours: body.weeks_12_hours,
                        weeks18Hours: body.weeks_18_hours,
                        weeks24Hours: body.weeks_24_hours,
                        vendorCertifications: body.vendor_certifications
                    };
                    if (result.vendorCertifications) {
                        Array(10)
                            .fill(1)
                            .forEach(function (value, index) {
                            result["programVendor" + index] = result.vendorCertifications[index] || "";
                        });
                    }
                    return [2, result];
            }
        });
    });
}
exports.getProgramCosts = getProgramCosts;
function saveAnswers(taskUserId, data) {
    return __awaiter(this, void 0, void 0, function () {
        var url, configuration, res, body, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = process.env.TASKS_API + "/update-only-answers/" + taskUserId;
                    configuration = {
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            auth_token: "Bearer " + window.token
                        }
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, axios_1.default.post(url, data, configuration)];
                case 2:
                    res = _a.sent();
                    body = res.data;
                    return [2, body];
                case 3:
                    error_2 = _a.sent();
                    throw {
                        error: error_2,
                        payload: data,
                        url: url
                    };
                case 4: return [2];
            }
        });
    });
}
exports.saveAnswers = saveAnswers;
function submitAnswers(taskUserId, data) {
    return __awaiter(this, void 0, void 0, function () {
        var url, configuration, res, body, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = process.env.TASKS_API + "/answer/" + taskUserId;
                    configuration = {
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            auth_token: "Bearer " + window.token
                        }
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, axios_1.default.post(url, data, configuration)];
                case 2:
                    res = _a.sent();
                    body = res.data;
                    return [2, body];
                case 3:
                    error_3 = _a.sent();
                    throw {
                        error: error_3,
                        payload: data,
                        url: url
                    };
                case 4: return [2];
            }
        });
    });
}
exports.submitAnswers = submitAnswers;
function submit() {
    return __awaiter(this, void 0, void 0, function () {
        var taskUserId, token, pdf, _a, post_main_form, check, url, _b, status_1, body, error_4;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    taskUserId = window.taskUserId, token = window.token, pdf = window.pdf, _a = window.post_main_form, post_main_form = _a === void 0 ? "" : _a;
                    return [4, pdf.validate()];
                case 1:
                    check = _c.sent();
                    if (!check) {
                        alert("Please check errors");
                        return [2];
                    }
                    pdf.setLoading(true);
                    url = "/answer/" + taskUserId;
                    _c.label = 2;
                case 2:
                    _c.trys.push([2, 4, , 5]);
                    return [4, sendRequest(pdf.json_data, url)];
                case 3:
                    _b = _c.sent(), status_1 = _b.status, body = _b.body;
                    pdf.setLoading(false);
                    if (status_1 !== 200) {
                        return [2];
                    }
                    showSuccessPage(body._id);
                    return [3, 5];
                case 4:
                    error_4 = _c.sent();
                    console.log(error_4);
                    return [3, 5];
                case 5: return [2];
            }
        });
    });
}
exports.submit = submit;
function sendRequest(json_data, url) {
    return __awaiter(this, void 0, void 0, function () {
        var rawResponse, body, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, fetch("" + process.env.TASKS_API + url, {
                        method: "POST",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            auth_token: "Bearer " + window.token
                        },
                        body: JSON.stringify(json_data)
                    })];
                case 1:
                    rawResponse = _a.sent();
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4, rawResponse.json()];
                case 3:
                    body = _a.sent();
                    return [3, 5];
                case 4:
                    e_1 = _a.sent();
                    body = {};
                    return [3, 5];
                case 5: return [2, { status: rawResponse.status, body: body }];
            }
        });
    });
}
function showSuccessPage(id) {
    return __awaiter(this, void 0, void 0, function () {
        var completedUrl;
        return __generator(this, function (_a) {
            completedUrl = window.completedUrl;
            window.top.location.href = completedUrl;
            return [2];
        });
    });
}
function getSchoolPerformanceData(programNumber) {
    return __awaiter(this, void 0, void 0, function () {
        var url, configuration, res, error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = process.env.FORM_TASK_API + "/v1/formData/asher_student_performance/" + programNumber;
                    configuration = {
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            authorization: "Bearer " + window.token
                        }
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, axios_1.default.get(url, configuration)];
                case 2:
                    res = _a.sent();
                    return [2, res.data.payload];
                case 3:
                    error_5 = _a.sent();
                    throw {
                        error: error_5,
                        url: url
                    };
                case 4: return [2];
            }
        });
    });
}
exports.getSchoolPerformanceData = getSchoolPerformanceData;
function getSchoolPerformanceTexas(programNumber) {
    return __awaiter(this, void 0, void 0, function () {
        var url, configuration, res, error_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = process.env.FORM_TASK_API + "/v1/schoolPerformance/" + programNumber;
                    configuration = {
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            authorization: "Bearer " + window.token
                        }
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, axios_1.default.get(url, configuration)];
                case 2:
                    res = _a.sent();
                    return [2, res.data.payload];
                case 3:
                    error_6 = _a.sent();
                    throw {
                        error: error_6,
                        url: url
                    };
                case 4: return [2];
            }
        });
    });
}
exports.getSchoolPerformanceTexas = getSchoolPerformanceTexas;
//# sourceMappingURL=data:application/json;base64,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